import { apiClient } from "./apiClient";
import { sessionService } from "./sessionService";

// Mantenemos getCurrentUser por compatibilidad para no romper otras partes de la app de inmediato
export const getCurrentUser = () => {
    return sessionService.getCurrentUser();
};

export const getInfoUser = async (token: string, email: string) => {
    const response = await apiClient.post(`/accounts/get/user`, {
        token: token,
        data: { token: token, email: email }
    });
    return response.data;
}

export const getCardsUser = async (token: string, email: string, countryCode: string) => {
    try {
        const response = await apiClient.post(`/accounts/get/cardsUser`, {
            token: token,
            data: {
                email: email,
                countryCode: countryCode,
            }
        });
        return response.data;
    } catch (error) {
        return null;
    }
};

export const postAddCardAccount = async ( account: string, countryCode: string, cardName: string, cardNumber: string, cardExpDate: string, cardCvv: string, credit?: boolean | null
) => {
    try {
        const payload: any = {
            token: account,
            country: countryCode,
            card: cardNumber.replace(/\D/g, ''),
            expiration: cardExpDate,
            cvv: cardCvv.replace(/\D/g, ''),
            cardHolder: cardName,
            cardColor: "Azul",
            newFormat: true
        };

        const response = await apiClient.post(`/accounts/create/newCard`, payload);

        return { status: response.status, data: response.data };
    } catch (error: any) {
        return { status: 500 };
    }
}

export const deleteCardAccount = async (token: string, account: string, cardId: [any]) => {
    try {
        // En axios, para enviar un body en DELETE se usa la propiedad 'data' en las opciones (config)
        const response = await apiClient.delete(`/accounts/delete/deleteUserCard`, {
            data: { token: token, data: { email: account, card: cardId } }
        });
        return response.data;
    } catch (error) {
        return null;
    }
};
// recuperar E-Ticket de la cuenta del usuario
export const getETicketAccount = async (token: string, countryCode: string) => {
    console.log("🔍 [userServices.getETicketAccount] Enviando consulta de tickets al backend:", {
        url: `/service/orders/get/number/orderByAccountETicket`,
        token: token,
        countryCode: countryCode,
        payload: { token: token, data: { account: token, countryCode: countryCode } }
    });

    try {
        const response = await apiClient.post(`/service/orders/get/number/orderByAccountETicket`, {
            token: token,
            data: { account: token, countryCode: countryCode }
        });

        console.log("📥 [userServices.getETicketAccount] Respuesta completa del backend:", {
            status: response?.status,
            data: response?.data,
            ordersCount: Array.isArray(response?.data?.data) ? response.data.data.length : (response?.data?.data ? 1 : 0),
            rawOrders: response?.data?.data
        });
        if (response?.data?.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
            console.log("📦 [userServices.getETicketAccount] ORDEN CRUDA #1:", response.data.data[0]);
        }

        return response.data;
    } catch (error: any) {
        console.error("❌ [userServices.getETicketAccount] Error al consultar tickets en el backend:", {
            message: error?.message,
            status: error?.response?.status,
            data: error?.response?.data,
            config: error?.config
        });
        throw error;
    }
}
